const STATUS_TEXT = Object.freeze({
    PENDING: '待处理',
    PROCESSING: '处理中',
    SENDING: '发送中',
    SENT: '已发送',
    FAILED: '失败',
    SUCCESS: '成功',
    UNKNOWN: '结果未知',
    UNCONFIGURED: '通道未配置',
    SKIPPED: '已跳过',
    ACTIVE: '生效中',
    INACTIVE: '已失效',
    ENABLED: '已启用',
    DISABLED: '已停用',
    DRAFT: '草稿',
    PUBLISHED: '已发布',
    OFFLINE: '已下线',
    OPEN: '待处理',
    CLOSED: '已关闭',
    APPROVED: '已通过',
    REJECTED: '已驳回',
    CANCELED: '已取消',
    CANCELLED: '已取消',
    VOIDED: '已作废',
    UNPAID: '未到账',
    PENDING_CONFIRMATION: '待确认',
    PARTIAL_PAID: '部分到账',
    PAID: '已到账',
    ABNORMAL: '异常',
    PENDING_PAYMENT: '待回款',
    COMPLETED: '已完成',
    OVERDUE: '已逾期',
    PARTIALLY_ISSUED: '部分开票',
    ISSUED: '已开票',
    PENDING_WORK: '待作业',
    WORKING: '执行中',
    SUBMITTED: '已提交',
    NEED_SUPPLEMENT: '需补充',
    ABNORMAL_DELAYED: '异常或延期',
    FULL: '已满员',
    EXPIRED: '已过期',
    REVOKED: '已作废',
    CLAIMED: '已认领',
    UNBOUND: '已解绑',
    NEW: '新建',
    UNASSIGNED: '待分配',
    ASSIGNED: '已分配',
    FOLLOWING: '跟进中',
    CONVERTED: '已转化',
    RECYCLED: '已回收',
    QUALIFIED: '已确认有效',
    NEED_ANALYSIS: '待研判',
    QUOTING: '报价中',
    WON: '已成交',
    LOST: '已关闭',
    SIGNED: '已签署',
    EXECUTING: '执行中',
    ACCEPTANCE: '验收中',
    PENDING_ACCEPTANCE: '待验收',
    ACCEPTED: '验收通过',
    ARCHIVED: '已归档',
    PENDING_ARCHIVE: '待归档',
    NOT_OPEN: '未开放',
    OPENING: '开放中',
    PENDING_REVIEW: '待审核',
    REVIEWING: '审核中',
    REVISION_REQUIRED: '需整改',
})

const ROLE_TEXT = Object.freeze({
    SUPER_ADMIN: '超级管理员',
    ADMIN: '管理员',
    SALES: '销售',
    PROJECT_MANAGER: '项目经理',
    MANAGER: '项目经理',
    FINANCE: '财务',
    OPERATION: '运营',
    OPERATIONS: '运营',
    CUSTOMER: '签约客户',
    CHANNEL: '合作生态',
    PARTNER: '合作生态',
    PILOT: '飞手',
    FLIGHT_PILOT: '飞手',
})

const TYPE_TEXT = Object.freeze({
    VAT_NORMAL: '增值税普通发票',
    VAT_SPECIAL: '增值税专用发票',
    TEXT: '文本',
    NUMBER: '数字',
    BOOLEAN: '开关',
    VIDEO: '视频',
    DOCUMENT: '文档',
    NORMAL_LOG: '普通日志',
    COMPARE_BEFORE: '清洁前留底',
    COMPARE_MIDDLE: '清洁中留痕',
    COMPARE_AFTER: '清洁后对比',
    SYSTEM_ACCOUNT: '后台系统账号',
    CUSTOMER_CONTACT: '客户联系人',
    PARTNER_PROFILE: '合作生态档案',
    FLIGHT_PILOT: '飞手档案',
    CUSTOMER_FEEDBACK: '客户反馈',
    REVISION: '整改回传',
    ACCEPTANCE_CONFIRMATION: '验收确认',
    SELF_OPERATED: '平台自营',
    CHANNEL_COLLABORATION: '合作生态协同',
    UNDECIDED: '待确定',
})

const CHANNEL_TEXT = Object.freeze({
    IN_APP: '站内消息',
    WECHAT_MINIAPP: '小程序订阅消息',
    SMS: '短信',
    WECHAT_SERVICE_ACCOUNT: '微信服务号',
})

const SOURCE_TEXT = Object.freeze({
    AUTO_PHONE: '手机号自动识别',
    AUTO_BIND: '手机号自动识别',
    WECHAT_PHONE: '手机号自动识别',
    INVITATION: '邀请口令',
    INVITATION_CODE: '邀请口令',
    TASK_CODE: '任务码认领',
    PILOT_TASK_CODE: '任务码认领',
    ADMIN: '后台关联',
    ADMIN_CREATED: '后台创建',
    WECHAT_SESSION: '微信会话建档',
    MIGRATION: '历史迁移',
    PORTAL: '官网留资',
    MINIAPP: '小程序',
    WECHAT: '微信',
    CUSTOMER: '客户提交',
    FINANCE: '财务登记',
    LEGACY: '历史数据',
    MANUAL: '人工录入',
    CHANNEL_REFERRAL: '渠道转介绍',
    CUSTOMER_REFERRAL: '客户转介绍',
    OTHER: '其他来源',
})

const DATA_SCOPE_TEXT = Object.freeze({
    ALL: '全部数据',
    SELF: '本人数据',
    SELF_RESPONSIBLE: '本人负责',
    AUTHORIZED_PROJECT: '授权项目',
    ROLE_SCOPE: '角色范围',
    DEPARTMENT: '本部门数据',
    DEPARTMENT_AND_CHILDREN: '本部门及下级部门数据',
    ALL_DATA: '全部数据',
    FINANCE_AUTHORIZED: '财务授权',
    OPERATION_AUTHORIZED: '运营授权',
})

const DATA_DOMAIN_TEXT = Object.freeze({
    SALES: '销售业务',
    PROJECT: '项目业务',
    FINANCE: '财务业务',
    RESOURCE: '资源协同',
    SYSTEM: '系统管理',
    CONTENT: '内容管理',
})

const BIZ_TYPE_TEXT = Object.freeze({
    LEAD: '线索',
    CUSTOMER: '客户',
    CONTACT: '联系人',
    OPPORTUNITY: '商机',
    PRODUCT: '产品与服务',
    QUOTATION: '报价',
    CONTRACT: '合同',
    PROJECT: '项目',
    PARTNER: '合作生态',
    PARTNER_APPLICATION: '接单申请',
    FLIGHT_TASK: '作业任务',
    FLIGHT_PILOT: '飞手',
    PAYMENT_PLAN: '回款计划',
    PAYMENT: '回款',
    INVOICE: '发票',
    NOTICE: '通知',
    SYSTEM_ACCOUNT: '成员账号',
    SYSTEM_ROLE: '角色权限',
    SYSTEM_CONFIG: '系统配置',
})

const ACTION_TEXT = Object.freeze({
    READ: '查看',
    CREATE: '新增',
    UPDATE: '更新',
    DELETE: '删除',
    ENABLE: '启用',
    DISABLE: '停用',
    APPROVE: '通过',
    REJECT: '驳回',
    SUBMIT: '提交',
    ASSIGN: '分配',
    CLAIM: '领取',
    ARCHIVE: '归档',
    PUBLISH: '发布',
    OFFLINE: '下线',
    LOGIN: '登录',
    LOGOUT: '退出登录',
    EXPORT: '导出',
    RESET_PASSWORD: '重置密码',
    FORCE_LOGOUT: '强制退出',
})

const SCORE_GRADE_TEXT = Object.freeze({
    A: '4分',
    B: '3分',
    C: '2分',
    D: '1分',
})

const OPERATION_FIELD_TEXT = Object.freeze({
    status: '状态',
    stage: '阶段',
    enabled: '启用状态',
    roleCode: '角色',
    dataScope: '数据范围',
    type: '类型',
    action: '操作',
    ownerName: '负责人',
    projectManager: '项目经理',
    amount: '金额',
    remark: '备注',
    reason: '原因',
})

function operationCodeText(code) {
    return STATUS_TEXT[code] || ROLE_TEXT[code] || TYPE_TEXT[code] || BIZ_TYPE_TEXT[code]
        || ACTION_TEXT[code] || SOURCE_TEXT[code] || CHANNEL_TEXT[code] || DATA_SCOPE_TEXT[code]
        || DATA_DOMAIN_TEXT[code] || ''
}

function operationFieldFallback(fieldName) {
    const field = String(fieldName || '')
    if (/role/i.test(field)) return '未知角色'
    if (/type/i.test(field)) return '未知类型'
    if (/source/i.test(field)) return '未知来源'
    if (/action/i.test(field)) return '未知操作'
    if (/scope/i.test(field)) return '未知数据范围'
    if (/stage/i.test(field)) return '未知阶段'
    if (/status|enabled/i.test(field)) return '未知状态'
    return ''
}

// 只保留需求边界内已确认的品牌、通用缩写、文件格式和计量单位。
const APPROVED_VISIBLE_ENGLISH = new Set([
    'AI', 'CRM', 'PDF', 'JPG', 'JPEG', 'PNG', 'DOC', 'DOCX', 'XLS', 'XLSX', 'CSV', 'EXCEL',
    'IP', 'ID', 'URL', 'JSON', 'MB', 'GB', 'KB', 'TB', 'MP4', 'MYSQL', 'SAAS', 'ICP',
    'HTML', 'HTTP', 'HTTPS', 'CTRL+V', 'DJI', 'GPS', 'RTK', 'BPS', 'FPS', 'HZ', 'KHZ',
    'MHZ', 'GHZ', 'MM', 'CM', 'KM', 'KG', 'KW', 'KWH', 'DB', 'DBM',
])

function textOf(value) {
    return value === null || value === undefined ? '' : String(value).trim()
}

function hasChinese(value) {
    return /[\u3400-\u9fff]/.test(value)
}

function stripApprovedTechnicalFragments(value) {
    return value
        .replace(/\bhttps?:\/\/[^\s，。；、]+/gi, ' ')
        .replace(/\b[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}\b/gi, ' ')
        .replace(/\b[A-Z0-9_-]+(?:\.[A-Z0-9_-]+)*\.(?:pdf|jpe?g|png|docx?|xlsx?|csv|mp4|zip|rar)\b/gi, ' ')
        .replace(/\/[A-Z0-9._~!$&'()*+,;=:@%/-]+/gi, ' ')
        .replace(/\b[A-D](?=级)/g, ' ')
}

function isApprovedModelOrIdentifier(token) {
    return /^V\d+(?:\.\d+)*$/i.test(token)
        || /^[A-Z]{1,4}\d[A-Z0-9.-]*$/.test(token)
        || /^[A-Z]{1,6}-(?=[A-Z0-9.-]*\d)[A-Z0-9.-]+$/.test(token)
}

function unapprovedEnglishTokens(value) {
    const inspectableText = stripApprovedTechnicalFragments(textOf(value))
    return (inspectableText.match(/[A-Za-z][A-Za-z0-9+._-]*/g) || []).filter((token) => {
        if (APPROVED_VISIBLE_ENGLISH.has(token.toUpperCase())) return false
        return !isApprovedModelOrIdentifier(token)
    })
}

function isApprovedChineseText(value) {
    const text = textOf(value)
    return hasChinese(text) && unapprovedEnglishTokens(text).length === 0
}

function safeFallbackText(value, defaultValue) {
    const text = textOf(value)
    if (!text) return defaultValue
    if (!/[A-Za-z]/.test(text) || isApprovedChineseText(text)) return text
    return defaultValue
}

/** 把旧版接口错误中的已知操作编码翻译为中文，保留后端返回的具体业务原因。 */
function localizeKnownErrorContext(value) {
    const localized = textOf(value).replace(
        /(操作\s*[：:]\s*)([A-Z][A-Z0-9_]*)(?=\s*[）)。,；;]|$)/g,
        (matched, prefix, code) => ACTION_TEXT[code] ? `${prefix}${ACTION_TEXT[code]}` : matched,
    )
    // 未知操作编码不能导致整句业务原因被丢弃；仅隐藏协议编码，保留可理解的中文原因。
    return localized.replace(/[（(]\s*操作\s*[：:]\s*[A-Z][A-Z0-9_]*\s*[）)]/g, '').trim()
}

function resolveText(value, preferredName, mapping, fallback) {
    const name = textOf(preferredName)
    if (name && isApprovedChineseText(name)) return name
    const code = textOf(value)
    if (!code) return fallback
    if (isApprovedChineseText(code)) return code
    return mapping[code] || mapping[code.toUpperCase()] || fallback
}

/** 系统字段只允许返回中文名称，未知编码统一使用中文兜底。 */
export function displayStatus(value, preferredName, fallback = '未知状态') {
    return resolveText(value, preferredName, STATUS_TEXT, safeFallbackText(fallback, '未知状态'))
}

export function displayRole(value, preferredName, fallback = '未知角色') {
    return resolveText(value, preferredName, ROLE_TEXT, safeFallbackText(fallback, '未知角色'))
}

export function displayType(value, preferredName, fallback = '未知类型') {
    return resolveText(value, preferredName, TYPE_TEXT, safeFallbackText(fallback, '未知类型'))
}

export function displayChannel(value, preferredName, fallback = '未知通道') {
    return resolveText(value, preferredName, CHANNEL_TEXT, safeFallbackText(fallback, '未知通道'))
}

export function displaySource(value, preferredName, fallback = '未知来源') {
    return resolveText(value, preferredName, SOURCE_TEXT, safeFallbackText(fallback, '未知来源'))
}

export function displayDataScope(value, preferredName, fallback = '未知数据范围') {
    return resolveText(value, preferredName, DATA_SCOPE_TEXT, safeFallbackText(fallback, '未知数据范围'))
}

export function displayDataDomain(value, preferredName, fallback = '未知业务域') {
    return resolveText(value, preferredName, DATA_DOMAIN_TEXT, safeFallbackText(fallback, '未知业务域'))
}

export function displayBizType(value, preferredName, fallback = '未知业务对象') {
    return resolveText(value, preferredName, BIZ_TYPE_TEXT, safeFallbackText(fallback, '未知业务对象'))
}

export function displayAction(value, preferredName, fallback = '未知操作') {
    return resolveText(value, preferredName, ACTION_TEXT, safeFallbackText(fallback, '未知操作'))
}

/** A～D 仅保留为接口协议值，评价界面始终显示为4分～1分。 */
export function displayScoreGrade(value, fallback = '暂无评分') {
    const code = textOf(value).toUpperCase()
    return SCORE_GRADE_TEXT[code] || safeFallbackText(fallback, '暂无评分')
}

export function displayValueType(value) {
    return displayType(value, '', '其他')
}

/** 操作日志中的枚举快照只替换已知编码，避免把用户填写内容误当成系统状态。 */
export function displayOperationState(value) {
    const text = textOf(value)
    if (!text) return '--'
    const resolveStateValue = (item, fieldName = '') => {
        if (item === true) return '是'
        if (item === false) return '否'
        if (item === null || item === undefined || item === '') return '无'
        if (Array.isArray(item)) return item.map((entry) => resolveStateValue(entry, fieldName)).join('、')
        if (typeof item === 'object') {
            return Object.entries(item).map(([key, entryValue]) => (
                `${OPERATION_FIELD_TEXT[key] || '字段'}：${resolveStateValue(entryValue, key)}`
            )).join('；')
        }
        const itemText = String(item)
        const fieldFallback = operationFieldFallback(fieldName)
        if (fieldFallback && /^[A-Za-z][A-Za-z0-9_]*$/.test(itemText)) {
            return operationCodeText(itemText.toUpperCase()) || fieldFallback
        }
        // 非枚举字段可能是用户填写的备注、型号或名称，不改写其中的英文内容。
        return itemText
    }
    if (/^[\[{]/.test(text)) {
        try {
            return resolveStateValue(JSON.parse(text))
        } catch (error) {
            // 历史日志可能不是标准 JSON，继续按普通枚举文本处理。
        }
    }
    if (/^(true|false)$/i.test(text)) return text.toLowerCase() === 'true' ? '是' : '否'
    if (/^[A-Za-z][A-Za-z0-9_]*$/.test(text)) {
        return operationCodeText(text.toUpperCase()) || '未知状态'
    }
    return resolveStateValue(text)
}

/** 把网络库、浏览器和第三方服务的英文错误收口成用户可理解的中文。 */
export function normalizeUserMessage(message, fallback = '操作失败，请稍后重试。') {
    const text = localizeKnownErrorContext(message)
    const safeFallback = safeFallbackText(fallback, '操作失败，请稍后重试。')
    if (!text) return safeFallback
    if (text === 'MULTI_ROLE_CONFLICT_CONFIRM_REQUIRED') {
        return '检测到当前账号存在多重身份，请确认操作身份后继续。'
    }
    if (/timeout|ECONNABORTED|ETIMEDOUT/i.test(text)) return '请求超时，请稍后重试。'
    if (/network error|failed to fetch|load failed|request:fail|ERR_NETWORK/i.test(text)) return '网络连接异常，请检查网络后重试。'
    if (/access denied|forbidden|status code 403/i.test(text)) return '当前账号没有执行此操作的权限。'
    if (/unauthorized|status code 401/i.test(text)) return '登录状态已失效，请重新登录。'
    if (/not found|status code 404/i.test(text)) return '请求的功能或数据不存在。'
    if (/internal server error|status code 5\d\d/i.test(text)) return '系统服务异常，请稍后重试。'
    if (/unexpected token|json parse|parse error/i.test(text)) return '系统返回的数据格式异常，请稍后重试。'
    if (/errcode|errmsg|unknown error|invalid credential|invalid token|invalid access|signature error/i.test(text)) {
        return safeFallback
    }
    if (/\b(?:error|exception|failed|failure|invalid|unsupported|undefined|stack|trace|sql|jdbc|axios|promise|constraint|database)\b|null\s*pointer|duplicate\s+key|connection\s+(?:refused|reset)|java\.|\b[A-Z]+_(?:ERROR|FAILED|INVALID|EXCEPTION|NOT_FOUND)\b/i.test(text)) {
        return safeFallback
    }
    if (isApprovedChineseText(text)) return text
    return safeFallback
}
